import BooleanSetting from '../helpers/boolean_setting.vue'
import IntegerSetting from '../helpers/integer_setting.vue'
import StringSetting from '../helpers/string_setting.vue'
import GroupSetting from '../helpers/group_setting.vue'
import AttachmentSetting from '../helpers/attachment_setting.vue'
import ListSetting from '../helpers/list_setting.vue'
import ListTupleSetting from '../helpers/list_tuple_setting.vue'
import MapSetting from '../helpers/map_setting.vue'

import SharedComputedObject from '../helpers/shared_computed_object.js'

const FederationTab = {
  provide () {
    return {
      defaultDraftMode: true,
      defaultSource: 'admin'
    }
  },
  components: {
    BooleanSetting,
    IntegerSetting,
    StringSetting,
    AttachmentSetting,
    ListSetting,
    ListTupleSetting,
    GroupSetting,
    MapSetting
  },
  computed: {
    ...SharedComputedObject()
  }
}

export default FederationTab
